export default {
    CREATE_STUDENT_EXAMS_REQUEST: 'CREATE_STUDENT_EXAMS_REQUEST',
    CREATE_STUDENT_EXAMS_SUCCESS: 'CREATE_STUDENT_EXAMS_SUCCESS',
    CREATE_STUDENT_EXAMS_FAIL: 'CREATE_STUDENT_EXAMS_FAIL',

    CREATE_TAG_EXAM_REQUEST: 'CREATE_TAG_EXAM_REQUEST',
    CREATE_TAG_EXAM_SUCCESS: 'CREATE_TAG_EXAM_SUCCESS',
    CREATE_TAG_EXAM_FAIL: 'CREATE_TAG_EXAM_FAIL',
    RESTORE_TAG_EXAM_SESSION: 'RESTORE_TAG_EXAM_SESSION',
    CLEAR_TAG_EXAM_SESSION: 'CLEAR_TAG_EXAM_SESSION',

    GET_STUDENT_EXAMS_REQUEST: 'GET_STUDENT_EXAMS_REQUEST',
    GET_STUDENT_EXAMS_SUCCESS: 'GET_STUDENT_EXAMS_SUCCESS',
    GET_STUDENT_EXAMS_FAIL: 'GET_STUDENT_EXAMS_FAIL',

    GET_STUDENT_TAGS_REQUEST: 'GET_STUDENT_TAGS_REQUEST',
    GET_STUDENT_TAGS_SUCCESS: 'GET_STUDENT_TAGS_SUCCESS',
    GET_STUDENT_TAGS_FAIL: 'GET_STUDENT_TAGS_FAIL',

    GET_STUDENT_EXAM_QUESTIONS_REQUEST: 'GET_STUDENT_EXAM_QUESTIONS_REQUEST',
    GET_STUDENT_EXAM_QUESTIONS_SUCCESS: 'GET_STUDENT_EXAM_QUESTIONS_SUCCESS',
    GET_STUDENT_EXAM_QUESTIONS_FAIL: 'GET_STUDENT_EXAM_QUESTIONS_FAIL',

    ADD_STUDENT_EXAMS_LOADING: 'ADD_STUDENT_EXAMS_LOADING',
    ADD_STUDENT_EXAMS_CREATING: 'ADD_STUDENT_EXAMS_CREATING',
    ADD_STUDENT_TAGS_LOADING: 'ADD_STUDENT_TAGS_LOADING',
};
